
export default function QCTOSection() {
  const benefits = [
    'Nationally recognised qualifications',
    'Industry-relevant curriculum standards',
    'Quality assurance and regular audits',
    'Employer confidence in our graduates',
    'Seamless credit transfer opportunities',
    'Compliance with national skills frameworks',
    'Access to government funding programmes',
    'International recognition potential'
  ];

  return (
    <section className="section-wrap bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Content */}
          <div>
            <h2 className="section-heading">
              Why QCTO Accreditation Matters
            </h2>
            
            <div className="space-y-6 text-gray-600">
              <p className="text-lg leading-relaxed">
                The Quality Council for Trades and Occupations (QCTO) is South Africa's quality 
                assurance body for occupational qualifications. Our full accreditation means you 
                can trust that our programmes meet the highest national standards.
              </p>
              
              <p className="leading-relaxed">
                QCTO accreditation ensures that our qualifications are not only recognised by 
                employers but also contribute meaningfully to South Africa's skills development 
                objectives. This accreditation is your guarantee of quality, relevance, and value.
              </p>
            </div>

            <div className="mt-8">
              <h3 className="text-xl font-semibold text-[#1A1A1A] mb-6">Benefits of Our QCTO Accreditation:</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {benefits.map((benefit, index) => (
                  <div key={index} className="flex items-start">
                    <i className="ri-check-double-line text-[#2D7F3E] mt-1 mr-3 flex-shrink-0"></i>
                    <span className="text-gray-600">{benefit}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Certificate and Details */}
          <div className="space-y-8">
            {/* Cape Town Accreditation Details */}
            <div className="green-panel bg-[#2D7F3E] text-white rounded-xl p-8">
              <h3 className="text-xl font-normal mb-4">Cape Town Campus Accreditation</h3>
              <div className="space-y-3">
                <div className="flex justify-between">
                  <span className="text-white/80">Status:</span>
                  <span className="font-semibold">Fully Accredited</span>
                </div>
                <div className="flex flex-col gap-1 sm:flex-row sm:justify-between sm:gap-6">
                  <span className="text-white/80">Skills Development Provider (SDP):</span>
                  <span className="font-semibold sm:text-right break-words">07-QCTO/SDP090925152814</span>
                </div>
                <div className="flex flex-col gap-1 sm:flex-row sm:justify-between sm:gap-6">
                  <span className="text-white/80">Assessment Centre:</span>
                  <span className="font-semibold sm:text-right break-words">01-QCTO/AC-TTC011025150627</span>
                </div>
              </div>
              
              <div className="mt-6 pt-6 border-t border-white/20">
                <div className="flex items-center">
                  <i className="ri-map-pin-line text-2xl mr-3"></i>
                  <div>
                    <div className="font-semibold">Cape Town Campus</div>
                    <div className="text-sm text-white/80">Western Cape training facility</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Main Accreditation Details */}
            <div className="green-panel bg-[#2D7F3E] text-white rounded-xl p-8">
              <h3 className="text-xl font-normal mb-4">Johannesburg Campus Accreditation</h3>
              <div className="space-y-3">
                <div className="flex justify-between">
                  <span className="text-white/80">Status:</span>
                  <span className="font-semibold">Fully Accredited</span>
                </div>
                <div className="flex flex-col gap-1 sm:flex-row sm:justify-between sm:gap-6">
                  <span className="text-white/80">Skills Development Provider (SDP):</span>
                  <span className="font-semibold sm:text-right break-words">07-QCTO/SDP090925152814</span>
                </div>
                <div className="flex flex-col gap-1 sm:flex-row sm:justify-between sm:gap-6">
                  <span className="text-white/80">Assessment Centre:</span>
                  <span className="font-semibold sm:text-right break-words">07-QCTO/AC-TTC281025085133</span>
                </div>
              </div>
              
              <div className="mt-6 pt-6 border-t border-white/20">
                <div className="flex items-center">
                  <i className="ri-map-pin-line text-2xl mr-3"></i>
                  <div>
                    <div className="font-semibold">Midrand Campus</div>
                    <div className="text-sm text-white/80">Johannesburg training facility</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
